/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KinnserPatientCreatedPatientSavedValuesInner
 */
export interface KinnserPatientCreatedPatientSavedValuesInner {
    /**
     * Patient field name, e.g. primary_insurance_key
     */
    key: string;
    /**
     * 
     */
    values: Array<string>;
    /**
     * WellSky option labels for dropdowns; empty otherwise
     */
    labels: Array<string>;
}

/**
 * Check if a given object implements the KinnserPatientCreatedPatientSavedValuesInner interface.
 */
export function instanceOfKinnserPatientCreatedPatientSavedValuesInner(value: object): value is KinnserPatientCreatedPatientSavedValuesInner {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    if (!('labels' in value) || value['labels'] === undefined) return false;
    return true;
}

export function KinnserPatientCreatedPatientSavedValuesInnerFromJSON(json: any): KinnserPatientCreatedPatientSavedValuesInner {
    return KinnserPatientCreatedPatientSavedValuesInnerFromJSONTyped(json, false);
}

export function KinnserPatientCreatedPatientSavedValuesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserPatientCreatedPatientSavedValuesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'values': json['values'],
        'labels': json['labels'],
    };
}

export function KinnserPatientCreatedPatientSavedValuesInnerToJSON(json: any): KinnserPatientCreatedPatientSavedValuesInner {
    return KinnserPatientCreatedPatientSavedValuesInnerToJSONTyped(json, false);
}

export function KinnserPatientCreatedPatientSavedValuesInnerToJSONTyped(value?: KinnserPatientCreatedPatientSavedValuesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'values': value['values'],
        'labels': value['labels'],
    };
}

